<machine-form [processing]="processing" (toggleCreateMachine)="create($event)" (toggleCancel)="goToBack()"> </machine-form>
